function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*
	Source: https://gitlab.owd.io/kamil.kondratowicz/form-validation/-/tree/v2/form-validator
	This file has been modified to meet the project requirements.
*/
import { deepAssign } from './helpers';
import { date, email, phone, required, instagram } from './rules'; // eslint-disable-next-line import/prefer-default-export

export var FormValidator = /*#__PURE__*/function () {
  function FormValidator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, FormValidator);

    this.options = this.mergeOptions(options);
    this.form = this.options.element;
    this.onFieldError = this.options.onFieldError;
    this.onFormError = this.options.onFormError;
    this.formFields = _toConsumableArray(this.form.querySelectorAll('[data-rules]:not([data-rules=""])'));
    this.errorElements = {};
    this.createErrorElements();
    this.initAttrs();
  }

  _createClass(FormValidator, [{
    key: "mergeOptions",
    value: function mergeOptions() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var defaultOptions = {
        element: document.querySelector('[data-form-validator]'),
        rules: {
          date: date,
          email: email,
          phone: phone,
          required: required,
          instagram: instagram
        },
        errorElementClass: 'form-error',
        onFieldError: function onFieldError() {},
        onFormError: function onFormError() {}
      };
      return deepAssign({})(defaultOptions, options);
    }
  }, {
    key: "initAttrs",
    value: function initAttrs() {
      this.form.setAttribute('novalidate', '');
    }
  }, {
    key: "createErrorElements",
    value: function createErrorElements() {
      var errorElementClass = this.options.errorElementClass; // eslint-disable-next-line no-restricted-syntax

      var _iterator = _createForOfIteratorHelper(this.formFields),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var field = _step.value;
          var name = field.name,
              parentNode = field.parentNode;
          var errorElement = document.createElement('span');
          errorElement.classList.add(errorElementClass);
          parentNode.appendChild(errorElement);
          this.errorElements[name] = errorElement;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "getValidator",
    value: function getValidator(rule) {
      var rules = this.options.rules;

      if (rules[rule]) {
        return rules[rule];
      }

      return null;
    }
  }, {
    key: "isFieldVisible",
    value: function isFieldVisible(field) {
      field = field.closest('.form__group') || field;
      return !!(field.offsetWidth || field.offsetHeight || field.getClientRects().length);
    }
  }, {
    key: "isSelectableField",
    value: function isSelectableField(type) {
      return ['checkbox', 'radio'].includes(type);
    }
  }, {
    key: "validateField",
    value: function validateField(field) {
      var _dataset$rules$split, _dataset$rules;

      var name = field.name,
          value = field.value,
          checked = field.checked,
          dataset = field.dataset,
          type = field.type;
      var rules = (_dataset$rules$split = dataset === null || dataset === void 0 ? void 0 : (_dataset$rules = dataset.rules) === null || _dataset$rules === void 0 ? void 0 : _dataset$rules.split('|')) !== null && _dataset$rules$split !== void 0 ? _dataset$rules$split : [];

      for (var index = 0; index < rules.length; index++) {
        var rule = rules[index];
        var validator = this.getValidator(rule);

        if (!validator) {
          // eslint-disable-next-line no-continue
          continue;
        }

        var validationResult = validator(this.isSelectableField(type) ? checked : value);

        if (typeof validationResult === 'string') {
          return {
            name: name,
            rule: rule,
            type: type,
            message: validationResult
          };
        }
      }

      return null;
    }
  }, {
    key: "isFieldValid",
    value: function isFieldValid(field) {
      var name = field.name,
          dataset = field.dataset;
      var fieldElement = field.closest(dataset.errorOnParent) || field;
      var errorElement = this.errorElements[name];
      var isValid = this.validateField(field);

      if (!isValid) {
        fieldElement.classList.remove('has-error');
        fieldElement.classList.add('is-valid');

        if (errorElement && errorElement.textContent) {
          errorElement.textContent = '';
        }
      } else {
        errorElement.textContent = isValid.message;
        fieldElement.classList.remove('is-valid');
        fieldElement.classList.add('has-error');
        this.onFieldError(fieldElement);
      }

      return isValid;
    }
  }, {
    key: "isFormValid",
    value: function isFormValid() {
      var invalidFields = []; // eslint-disable-next-line no-restricted-syntax

      var _iterator2 = _createForOfIteratorHelper(this.visibleFormFields),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var field = _step2.value;
          var isFieldValid = this.isFieldValid(field);

          if (!isFieldValid) {
            invalidFields.push(field);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      if (invalidFields.length) {
        this.onFormError(invalidFields);
      }

      return !invalidFields.length;
    }
  }, {
    key: "visibleFormFields",
    get: function get() {
      var _this = this;

      return this.formFields.filter(function (field) {
        return _this.isFieldVisible(field);
      });
    }
  }]);

  return FormValidator;
}();